<script setup lang="ts">
/*
 * One payment method as a mark: the simple-icons glyph for a known slug
 * (utils/brand-icons.ts), else the admin-supplied `icon` image URL, else the
 * name as text. Shared by the storefront (footer, home tile) and the admin
 * (payment methods page, invoice method picker). Monochrome (currentColor)
 * so it reads on any tile tone; the parent sets colour. `labelled` adds the
 * name after a glyph/image (admin lists); without it a mark stands alone.
 */
import { computed, ref, watch } from 'vue';
import BrandMark from './BrandMark.vue';
import { paymentIcon } from '../utils/brand-icons';

const props = defineProps<{ slug: string; name: string; icon?: string; labelled?: boolean }>();

const glyph = computed(() => paymentIcon(props.slug));
// A dead icon URL falls through to the name instead of a broken image.
const imageFailed = ref(false);
watch(() => props.icon, () => { imageFailed.value = false; });
</script>

<template>
  <span class="inline-flex items-center gap-2">
    <BrandMark v-if="glyph" :icon="glyph" class="h-4 w-4 shrink-0" />
    <img v-else-if="icon && !imageFailed" :src="icon" :alt="labelled ? '' : name" class="h-4 w-auto shrink-0" loading="lazy" @error="imageFailed = true" />
    <span v-if="labelled || (!glyph && (!icon || imageFailed))">{{ name }}</span>
  </span>
</template>
